export const deviationTypeSchema: any = {
  id: "",
  deviationType: "",
  createdBy: "",
  description: "",
  organizationId: "",
};
